var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { boxStyle, getResponsiveProp } from '../../styles';
import { containerBaseStyles, containerWidthStyles } from './styles';
var Root = styled.div(boxStyle, containerBaseStyles, containerWidthStyles);
export function Container(props) {
  var widthProp = props.width,
      restProps = __rest(props, ["width"]);

  var width = getResponsiveProp(widthProp, [2]);
  return React.createElement(Root, Object.assign({
    "data-ui": "Container"
  }, restProps, {
    width: width
  }));
}